import { render, staticRenderFns } from "./Boek.vue?vue&type=template&id=41241232&"
import script from "./Boek.vue?vue&type=script&lang=js&"
export * from "./Boek.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/dev/tafelgasten.outlawz.dev/web/app/themes/tafelgasten/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41241232')) {
      api.createRecord('41241232', component.options)
    } else {
      api.reload('41241232', component.options)
    }
    module.hot.accept("./Boek.vue?vue&type=template&id=41241232&", function () {
      api.rerender('41241232', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/vue/Boek.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/Boek.vue
// module id = 338
// module chunks = 0